import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDownsize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDownsize"><Path fillRule="evenodd" clipRule="evenodd" d="M10 10H3V8.5H8.5V3H10V10Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 10H14V3H15.5V8.5H21V10Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M14 21V14H21V15.5H15.5V21H14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 21V15.5H3V14H10V21H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDownsize;
